<template>
  <footer class="footer " :class="getPath(route.path)==''||getPath(route.path)=='support'||getPath(route.path)=='product' ? 'fixed' : ''">
    <!-- <img src="~/img/icon_copyright.png" alt="" class="footer-copyright"> -->
    <!-- <span>{{ t('footer.copyright')}}</span> -->
    <client-only>
      <div class="link-box">
        <nuxt-link :to="item.linkUrl" v-for="item in linkArr" class="link-item" :title="item.linkDesc" target="_blank" v-show="item.status == '0'">
          <img :src="item.linkLogoUrl" alt="" class="header-logo">
        </nuxt-link>
      </div>
    </client-only>
    <img src="~/img/logo_new.png" alt="" class="footer-logo">
  </footer>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n();
  const route = useRoute()
  const getPath = (x:any)=>{
    return x.split("/")[1]
  }

  // 底部友链
  let linkArr:any = ref([])
  const getLink = async() => { // 获取数据
    try {
      const response = await listFriendlyLink({});
      if(response.data.length){
        linkArr.value = response.data
      }
    } catch (error) {
    }
  }
  getLink()
</script>

<style lang='scss' scoped>
  .footer{
    bottom: 0;
    width: 100%;
    z-index: 97;
    background-color: #f2f2f2;
    height: 60px;
    line-height: 60px;
    padding: 0 80px 0 70px;
    .footer-copyright{
      height: 20px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .link-box{
      display: inline-block;
      // margin-left: 55px;
      .link-item{
        width: 22px;
        margin-right: 15px;
        cursor: pointer;
        display: inline-block;
        img{
          height: 22px;
          vertical-align: middle;
        }
      }
    }
    .footer-logo{
      float: right;
      // width: 70px;
      // margin-top: 10px;
      height: 20px;
      margin-top: 20px;
    }
  }
</style>